import React from 'react'

import styles from './EpisodesSeparatorCard.module.sass'

const EpisodeSeparatorCard = (props) => {
	const { className, data, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['root'] || ''} ${className || ''}`}
		>
			<div
				className={`${styles['separator-conatiner']} ${
					data?.isLastEpisode ? styles['is-last-episode'] : ''
				}`}
			>
				<small>{data?.title}</small>
				<span className={styles['separator']}></span>
			</div>
			<div className={styles['separator-conatiner']}>
				<small>{data?.prevEpisode?.title}</small>
				<span className={styles['separator']} />
			</div>
		</div>
	)
}

EpisodeSeparatorCard.displayName = 'EpisodeSeparatorCard'
EpisodeSeparatorCard.defaultHeight = 42
export default EpisodeSeparatorCard
